import { useTranslation } from 'react-i18next'
import type { AvailableAmountInWalletTextButtonProps } from './types'

import { BaseText, BaseView } from '@/components/base'
import { useGetWalletDataByCryptoCode } from '@/hooks/useGetWalletDataByCryptoCode'
import { currencyUtils } from '@/utils/currency'

const { formatDynamicCurrency } = currencyUtils

export const AvailableAmountInWalletTextButton = ({
  customAmount,
  cryptoCode,
  onPress,
  className = '',
  style = {},
}: AvailableAmountInWalletTextButtonProps) => {
  const { t } = useTranslation()

  const selectedCryptoWalletData = useGetWalletDataByCryptoCode({ cryptoCode })

  const formattedAmount = formatDynamicCurrency({
    amount: customAmount || (selectedCryptoWalletData?.amount ?? '0'),
    currencyCode: selectedCryptoWalletData?.code ?? 'USDT',
  })

  const handleClick = () => {
    onPress({
      amount: Number(selectedCryptoWalletData?.amount ?? '0'),
      amountWithoutNumberConversion:
        selectedCryptoWalletData?.amountWithoutNumberConversion ?? '0',
      pricePerUnit: selectedCryptoWalletData?.pricePerUnit ?? 0,
    })
  }

  return (
    <BaseView
      className={`cursor-pointer hover:opacity-80 transition-opacity ${className}`}
      style={{ alignSelf: 'flex-start', ...style }}
      onClick={handleClick}
    >
      <BaseText color="label.clickable" fontFamily="semibold">
        {t('form:actions.addMaximum', { formattedAmount })}
      </BaseText>
    </BaseView>
  )
}
